import { AppDispatch, RootState } from '@/redux/create-store';
import { selectCodeISO, selectStoreId } from '@/redux/slices/root.slice';
import { selectCartContent } from '@/redux/slices/cart.slice';
import { destroyCookie } from 'nookies';
import { toggleConfirmationModal } from '@/redux/slices/gui.slice';
import ModalChangeStoreForDeliveryCountry from '@/components/layout/modals/ModalChangeStoreForDeliveryCountry';
import UserService from '@/services/User.service';
import { selectCurrentStepLabel } from '@/redux/slices/checkout.slice';
import { validateCurrentCheckoutStepOrRedirect } from '@/redux/thunks/checkout/validateCurrentCheckoutStepOrRedirect';
import { COOKIES } from '@/constants/cookies';
import { STORE_ID } from '@/constants/stores';

export const validateAddressStep = async (state: RootState, dispatch: AppDispatch, userService: UserService) => {
  const storeId = selectStoreId(state);
  const codeISO = selectCodeISO(state);
  const cartContent = selectCartContent(state);
  const currentStep = selectCurrentStepLabel(state);
  const otherLanguagesByCountry = state.root.storeConf.otherLanguagesByCountry;

  let storeIdForPrice = state.gui.storeIdForPrice;

  if (storeIdForPrice === undefined) {
    storeIdForPrice = null;
  }

  let sourceCodeIso: string;
  if (storeId === STORE_ID.COM) {
    for (const [countryCodeIso, { languages }] of Object.entries(otherLanguagesByCountry) as any) {
      const founded = languages.find((lang: { storeId: string; storeIdForPrice: string; language: string }) =>
        lang.storeId === STORE_ID.COM &&
        lang.storeIdForPrice === storeIdForPrice &&
        lang.language === 'en'
      );

      if (founded) {
        sourceCodeIso = countryCodeIso;
        break;
      }
    }
  } else {
    sourceCodeIso = codeISO;
  }

  const countryShipping = cartContent.shipping.country;
  const languages = otherLanguagesByCountry[countryShipping]?.languages;
  const targetLanguage =
    storeId === STORE_ID.COM ?
      languages?.find((lang) => lang.language === 'en') :
      languages?.[0];

  if (targetLanguage !== undefined && targetLanguage.country !== sourceCodeIso) {
    const redirect = async (urlRedirect: string) => {
      if (targetLanguage.storeIdForPrice == null) {
        destroyCookie({}, COOKIES.STOREID_FOR_PRICE.NAME);
      }

      await userService.switchStoreUpdateCart({
        targetStoreId: targetLanguage.storeId,
        sourceStoreId: storeId,
        storeIdForPrice: targetLanguage.storeIdForPrice == null ? '' : targetLanguage.storeIdForPrice
      });
      window.location.href = urlRedirect;
    };

    const cancelAndContinue = () => {
      dispatch(toggleConfirmationModal({}));
      dispatch(validateCurrentCheckoutStepOrRedirect({ type: 'validateAndRedirect' }));
    };

    const { urlRedirect, productsUnavailable } = await userService.switchStore({
      targetStoreId: targetLanguage.storeId,
      sourceStoreId: storeId,
      storeIdForPrice: targetLanguage.storeIdForPrice == null ? '' : targetLanguage.storeIdForPrice,
      targetUrl: targetLanguage.url,
      sourceUrl: window.location.href,
      checkoutStep: currentStep
    });

    dispatch(toggleConfirmationModal({
      toTranslate: true,
      opened: true,
      title: 'common:selectDeliveryCountryRedirectModal.title',
      customContent: <ModalChangeStoreForDeliveryCountry productsUnavailable={productsUnavailable} isCheckout/>,
      confirm: {
        label: 'selectDeliveryCountryRedirectModal.confirm',
        action: async () => await redirect(urlRedirect)
      },
      cancel: {
        label: 'common:selectDeliveryCountryRedirectModal.cancel',
        action: () => cancelAndContinue()
      }
    }));
    return { continue: false };
  }
  return { continue: true };
};
